import EmptyItemCard from './emptyItemCardContainer'

export default EmptyItemCard
